import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 60px;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 0 60px;
`;

const StyledRightContainer = styled.div`
	display: flex;
	gap: 40px;
`;

const StyledMoneyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);

	${Text} {
		font-weight: 500;
		font-size: 18px;
	}
`;

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	margin: 0 10px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.5);
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		width: 20px;
		height: 20px;
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

export {
	StyledCloseButtonContainer,
	StyledContainer,
	StyledDot,
	StyledMoneyContainer,
	StyledRightContainer,
};
